export const MuiSelect = {
  styleOverrides: {
    select: {
      '&:focus': {
        backgroundColor: 'inherit',
      },
    },
  },
}
